import { RangePosition } from '@mui/x-date-pickers-pro';
import { getMinPickUp, getServiceHours, searchFormValuesToData } from '../lib';
import { useBranchSettings } from './useBranchSettings';
import { useSearchFormFieldValue } from './useSearchFormFieldValue';

export const useGetMinMaxTime = (position: RangePosition) => {
    const pickUpDate = useSearchFormFieldValue('pickUpDate');
    const pickUpTime = useSearchFormFieldValue('pickUpTime');
    const dropOffDate = useSearchFormFieldValue('dropOffDate');
    const dropOffTime = useSearchFormFieldValue('dropOffTime');
    const fleetTypeSlug = useSearchFormFieldValue('fleetType');
    const pickUpBranchCode = useSearchFormFieldValue('pickUpBranch');
    const dropOffBranchCode = useSearchFormFieldValue('dropOffBranch');
    const { pickUpBranch, fleetType, dropOffBranch } = searchFormValuesToData({
        fleetType: fleetTypeSlug,
        pickUpBranch: pickUpBranchCode,
        dropOffBranch: dropOffBranchCode,
    });
    const { pickUpBranchSettings, dropOffBranchSettings } = useBranchSettings();
    if (position === 'start' && pickUpBranch && fleetType) {
        const serviceHours = getServiceHours({ date: pickUpDate || pickUpTime, siteSettings: pickUpBranchSettings });
        return {
            minTime: getMinPickUp({ date: pickUpDate || pickUpTime, branch: pickUpBranch, fleetType }),
            maxTime: serviceHours?.close,
        };
    }

    if (position === 'end' && dropOffBranch && fleetType) {
        const serviceHours = getServiceHours({ date: dropOffDate || dropOffTime, siteSettings: dropOffBranchSettings });
        return {
            minTime: serviceHours?.open,
            maxTime: serviceHours?.close,
        };
    }

    return {
        minTime: undefined,
        maxTime: undefined,
    };
};
